module.exports = __webpack_public_path__ + "static/media/guess.d2e8511e.png";